import { render, staticRenderFns } from "./AutoPagination.vue?vue&type=template&id=32b47c74&scoped=true"
import script from "./AutoPagination.vue?vue&type=script&lang=js"
export * from "./AutoPagination.vue?vue&type=script&lang=js"
import style0 from "./AutoPagination.vue?vue&type=style&index=0&id=32b47c74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b47c74",
  null
  
)

export default component.exports